import { getOpParams } from 'utils/getOpParams';
import { getControlCenterOrigin } from 'utils/getControlCenterOrigin';
import { mfaManagementRoute } from 'routes/constants';
import { useOpQuery } from './useOpQuery';
import { useIdentityAndUser } from './useIdentityAndUser';
import { setWindowLocation } from '../../../altaLoginApp/helpers/setWindowLocation';

export const useHandleNeedsMfa = () => {
  const { userId, identityId } = useIdentityAndUser();
  const { orgId } = getOpParams();

  const { data: userRoles } = useOpQuery({
    apiEndpointName: 'listUserRoles',
    parameters: [orgId, Number(userId)],
    select: (response) => response.json.data,
  });

  const { data: mfaCredentials } = useOpQuery({
    apiEndpointName: 'listMfaCredentials',
    parameters: [Number(identityId)],
    select: (response) => response.json.data,
  });

  if (
    userRoles?.some((role) => role.isMfaRequired) &&
    mfaCredentials?.length === 0
  ) {
    const ccDomain = getControlCenterOrigin();

    setWindowLocation(`${ccDomain}/o/${orgId}${mfaManagementRoute}`);
  }
};
